<div class="mt-6 w-full flex flex-col gap-5">
  <p-toast></p-toast>
  <p-confirmdialog />
  <p-card>
    <ng-template #title>
      <h1>{{ 'catalog.openingHourTypes.title' | translate }}</h1>
    </ng-template>

    <div class="flex justify-end gap-2 mb-5">
      <p-button
        icon="fa fa-plus"
        [label]="'catalog.openingHourTypes.add' | translate"
        (onClick)="navigateToCreate()"
      />
    </div>

    <p-table
      [value]="service.items()"
      stripedRows
      showGridlines
      dataKey="id"
      [paginator]="true"
      [rows]="25"
      sortField="name"
      [sortOrder]="1"
      [scrollable]="true"
      [tableStyle]="{ 'min-width': '40rem' }"
    >
      <ng-template #header>
        <tr>
          <th pSortableColumn="name">
            {{ 'catalog.openingHourTypes.fields.name' | translate }}
            <p-sortIcon field="name" />
          </th>
          <th>{{ 'catalog.openingHourTypes.fields.public' | translate }}</th>
          <th>{{ 'catalog.openingHourTypes.rowCount' | translate }}</th>
          <th pFrozenColumn alignFrozen="right" class="w-32"></th>
        </tr>
      </ng-template>
      <ng-template #body let-row>
        <tr class="cursor-pointer" (click)="navigateToDetail(row)">
          <td>{{ row.name }}</td>
          <td>
            @if (row.public) {
              <p-tag severity="success" value="✓" />
            } @else {
              <p-tag severity="secondary" value="—" />
            }
          </td>
          <td>{{ hourCount(row) }}</td>
          <td pFrozenColumn alignFrozen="right">
            <div class="flex items-center justify-end gap-2">
              <button
                pButton
                type="button"
                icon="fa fa-pencil"
                text
                rounded
                severity="secondary"
                (click)="navigateToDetail(row); $event.stopPropagation()"
              ></button>
              <button
                pButton
                type="button"
                icon="fa fa-trash"
                text
                rounded
                severity="secondary"
                (click)="onRowDelete($event, row); $event.stopPropagation()"
              ></button>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template #emptymessage>
        <tr>
          <td colspan="4" class="text-center italic text-color-secondary py-6">
            {{ 'catalog.openingHourTypes.empty' | translate }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-card>
</div>
